/* eslint-disable react/prop-types */
import { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  SvgIcon
} from '@material-ui/core';
import { Search as SearchIcon } from 'react-feather';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

const CustomerListToolbar = ({
  clickToSearch,
  datesearch,
  handleChangeselect,
  selectvalue,
  fromdate,
  todate,
  handleSearchText
}) => {
  const [firstdate, setFirstDate] = useState(null);
  const [seconddate, setSecondDate] = useState(null);
  const [searchtext, setSearchtext] = useState('');
  const [bookedFilter, setBookedFilter] = useState('');

  // const { clickToSearch, datesearch, handleChangeselect, selectvalue } = props;

  const handleSearchInvNo = (inv) => {
    setSearchtext(inv);
    handleSearchText(inv);
  };

  useEffect(() => {
    setBookedFilter(selectvalue);

    if (fromdate) setFirstDate(new Date(fromdate)); // Convert to Date object
    if (todate) setSecondDate(new Date(todate));   // Convert to Date object

  }, [fromdate, todate]);


  return (
    // <Box {...props}>
    <Box>
      <Box sx={{ mt: 0 }}>
        <Card>
          <CardContent>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={3}>
                <Grid item xs={3} style={{ display: 'flex' }}>
                  <TextField
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon fontSize="small" color="action">
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )
                    }}
                    sx={{ width: '50ch' }}
                    placeholder="Search "
                    onChange={(e) => handleSearchInvNo(e.target.value)}
                    onKeyPress={(e) => clickToSearch(e, '1')}
                  />
                  <Button
                    variant="contained"
                    onClick={() => clickToSearch(searchtext, '2')}
                  >
                    Search
                  </Button>
                </Grid>

                <Grid item xs={2} style={{ display: 'grid' }}>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={bookedFilter}
                    onChange={(e) => {
                      setBookedFilter(e.target.value);
                      datesearch(firstdate, seconddate, e.target.value);
                    }
                    }
                  >
                    <MenuItem value={0}>Both</MenuItem>
                    <MenuItem value={1}>Settled</MenuItem>
                    <MenuItem value={2}>Unsettled</MenuItem>

                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="Settlement From Date"
                      value={firstdate || null}
                      format="yyyy-MM-dd"
                      onChange={(newValue) => {
                        datesearch(newValue, seconddate, bookedFilter);
                        setFirstDate(newValue);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={2}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="Settlement To Date"
                      value={seconddate}
                      onChange={(newValue) => {
                        datesearch(firstdate, newValue, bookedFilter);
                        setSecondDate(newValue);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                      format="yyyy-MM-dd"
                    />
                  </LocalizationProvider>
                </Grid>
                {/* <Grid item xs={3}>
                  <Button
                    color="primary"
                    onClick={() => {
                      datesearch(firstdate, seconddate);
                    }}
                  >
                    <SvgIcon fontSize="large" color="action">
                      <SearchIcon />
                    </SvgIcon>
                  </Button>
                </Grid> */}
              </Grid>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default CustomerListToolbar;
